import { render, staticRenderFns } from "./ComplianceExpiredElementsDrillDown.vue?vue&type=template&id=019dcd3e&"
import script from "./ComplianceExpiredElementsDrillDown.vue?vue&type=script&lang=ts&"
export * from "./ComplianceExpiredElementsDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports